import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Flashbar, FlashbarProps } from "@amzn/awsui-components-react/polaris";

import { RootState } from "../app/rootReducer";
import { removeNotification } from "./notificationConnector";

export const Notification = () => {
  const dispatch = useDispatch();
  const { notificationItems } = useSelector(
    (state: RootState) => state.notification
  );

  const flashBarItems: FlashbarProps.MessageDefinition[] = Object.entries(
    notificationItems
  ).map(([key, value]) => ({
    ...value,
    id: key,
    onDismiss: () => dispatch(removeNotification(parseInt(key, 10))),
  }));

  // Skip mounting the Flashbar entirely when there is nothing to show.
  // Cloudscape's Flashbar uses `react-transition-group` internally and
  // can leave a removed `<li>` frozen in the `awsui_exiting` state
  // (full height, opacity 1) when items churn during route changes —
  // for example, `fetchPorAsins` adds the Restricted-ASINs banner, a
  // route change triggers `NoFiltersPanel` to dispatch
  // `removeNotification` in the next commit, and TransitionGroup
  // loses the exit callback for the removed child. Unmounting the
  // whole Flashbar tree when items go to empty tears the stale node
  // down with it.
  if (flashBarItems.length === 0) {
    return null;
  }

  return (
    <Flashbar
      data-testid="notification-flashbar"
      items={flashBarItems}
      i18nStrings={{
        ariaLabel: "Notifications",
        errorIconAriaLabel: "Error",
        warningIconAriaLabel: "Warning",
        successIconAriaLabel: "Success",
        infoIconAriaLabel: "Info",
        inProgressIconAriaLabel: "In progress",
      }}
    />
  );
};
